// FÁZE 1 — Analyze hub: mřížka nástrojů (Recruitment Focus je jedním z nich).
import React from "react";
import { Link } from "react-router-dom";
import { Brain, Fire, Gauge, Timer, Sparkle, Crosshair, ChartLineUp, Broadcast, ArrowsClockwise, SquaresFour, Funnel, Binoculars, Barbell } from "@phosphor-icons/react";

const DISCOVERY = [
    { to: "/tools/recruitment-focus", label: "Recruitment Focus", icon: Brain, text: "Koho hledám a proč — AI Recruiter doporučí kandidáty s fit skóre" },
    { to: "/tools/player-finder", label: "Vyhledávač hráčů", icon: Funnel, text: "Jedna databáze — FDR, hauly, value, konzistence, výbušnost, žebříčky" },
    { to: "/tools/season-dna", label: "Team Season DNA", icon: Timer, text: "Analýza tvého poolu — 6 sezón historie" },
    { to: "/tools/finders", label: "Vyhledávače", icon: Sparkle, text: "Konzistentní · explozivní · value · dle soupeře" },
    { to: "/tools/hauls", label: "Hauly", icon: Fire, text: "Kdo nejčastěji dává 10+ bodů" },
    { to: "/tools/fdr-analyzer", label: "FDR Analyzer", icon: Gauge, text: "Výkon dle síly soupeře" },
    { to: "/tools/transfers", label: "Přestupy", icon: Timer, text: "Potvrzené reálné přestupy okna 2026" },
    { to: "/hidden-gems", label: "Hidden Gems", icon: Sparkle, text: "Skryté klenoty s nízkým ownership" },
    { to: "/predictions", label: "Predictions", icon: Crosshair, text: "Predikce bodů na 1–8 GW" },
    { to: "/market", label: "Market", icon: ChartLineUp, text: "Bandwagons & sell-offs" },
    { to: "/radar", label: "Incoming Radar", icon: Broadcast, text: "Noví hráči přicházející do PL" },
    { to: "/preseason", label: "Model přípravy", icon: Barbell, text: "Přáteláky, minutáž v přípravě a noví trenéři" },
    { to: "/rotation-fdr", label: "Rotation FDR", icon: ArrowsClockwise, text: "Rotace dle fixtures" },
    { to: "/rotation", label: "Hledání parťáka", icon: ArrowsClockwise, text: "Najdi rotačního parťáka — dvojice se doplňujícím rozpisem" },
    { to: "/fdr", label: "FDR Heatmapa", icon: SquaresFour, text: "Obtížnost rozpisu 20 týmů" },
    { to: "/tools/fixture-matrix", label: "Fixture Matrix", icon: SquaresFour, text: "Projekce bodů hráč × GW" },
];

export default function LabAnalyze() {
    return (
        <div className="space-y-8" data-testid="lab-analyze">
            <section className="space-y-3">
                <h2 className="font-display font-black uppercase text-base">Analytické nástroje</h2>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="discovery-tools">
                    {DISCOVERY.map((d) => (
                        <Link key={d.label} to={d.to}
                              className="border border-white/10 bg-black/40 p-4 flex items-start gap-3 hover:border-fa-mint/40 transition-colors group">
                            <d.icon size={18} className="text-fa-mint flex-shrink-0 mt-0.5" />
                            <div>
                                <div className="font-display font-bold text-sm group-hover:text-fa-mint transition-colors">{d.label}</div>
                                <div className="font-mono text-[9px] text-white/50 mt-0.5">{d.text}</div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            <section className="space-y-3">
                <h2 className="font-display font-black uppercase text-base">Týdenní predikce & komunita</h2>
                <div className="grid md:grid-cols-2 gap-3">
                <Link to="/bksa" data-testid="analyze-bksa-link"
                      className="border border-fa-yellow/30 bg-fa-yellow/5 p-4 flex items-start gap-3 hover:border-fa-yellow/60 transition-colors group block">
                    <Fire size={18} className="text-fa-yellow flex-shrink-0 mt-0.5" />
                    <div>
                        <div className="font-display font-bold text-sm group-hover:text-fa-yellow transition-colors">Buy · Keep · Sell · Avoid</div>
                        <div className="font-mono text-[9px] text-white/50 mt-0.5">4 predikce před deadlinem — uzamknou se a vyhodnotí po 1/3/8 GW. Sbírej Knowledge XP a Manager Rating.</div>
                    </div>
                </Link>
                <Link to="/scout" data-testid="analyze-scout-link"
                      className="border border-fa-sky/30 bg-fa-sky/5 p-4 flex items-start gap-3 hover:border-fa-sky/60 transition-colors group block">
                    <Binoculars size={18} className="text-fa-sky flex-shrink-0 mt-0.5" />
                    <div>
                        <div className="font-display font-bold text-sm group-hover:text-fa-sky transition-colors">Scout Hub — komunitní scouting</div>
                        <div className="font-mono text-[9px] text-white/50 mt-0.5">Vystav svůj focus, nebo scoutuj hráče pro ostatní. +1 Knowledge XP za tip, komunitní žebříčky.</div>
                    </div>
                </Link>
                </div>
            </section>
        </div>
    );
}
